import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChatRoutingModule } from './chat-routing.module';
import { ChatComponent } from './components/chat/chat.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FormsModule } from '@angular/forms';
import { ChatclientfinalComponent } from './components/chatclientfinal/chatclientfinal.component';
import { SharedModule } from '@shared/shared.module';


@NgModule({
  declarations: [
    ChatComponent,
    ChatclientfinalComponent
  ],
  imports: [
    CommonModule,
    ChatRoutingModule,
    FormsModule,
    SharedModule,
    NgxSpinnerModule

  ]
})
export class ChatModule { }
